import FromSeekAPI from './FromSeekAPI.js';
import ToSeekAPI from './ToSeekAPI.js';
/**
 * @namespace adapters
 * @description
 * The Seek REST models for data references & feature references are slightly
 * different than the ones defined in this package which is a superset of what
 * is accepted by the publisher REST models.
 *
 * In order to support the interaction between both systems of record, this
 * module includes two adapters which translate to/from Seek API compatible
 * types.
 */
export { FromSeekAPI, ToSeekAPI };
const adapters = {
    FromSeekAPI,
    ToSeekAPI,
};
export default adapters;
